import React, { useContext, useEffect, useState } from 'react'
import { CButton, CCol, CModal, CModalBody, CModalFooter, CModalHeader, CRow } from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'

const RosemaryHeaderModal = ({ componentData, modifyData, modalSpecificData, onCancel }) => {
  // const { modalData, isEdit } = modalSpecificData
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, setLoader } = useContext(AppContext)
  const [logoS3key, setLogoS3key] = useState('')
  const [heading1, setHeading1] = useState({ text: '', link: { type: '', data: {} } })
  const [heading2, setHeading2] = useState({ text: '', link: { type: '', data: {} } })
  const [heading3, setHeading3] = useState({ text: '', link: { type: '', data: {} } })
  const [heading4, setHeading4] = useState({ text: '', link: { type: '', data: {} } })
  const [signIn, setSignIn] = useState({ text: '', link: { type: 'LOGIN', data: {} } })
  const [ctaButton, setCtaButton] = useState({ text: '', link: { type: 'REGISTER', data: {} } })

  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState([])

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: 'mdImage',
        width: 162,
        height: 63,
        divwidth: '14.5rem',
        divheight: '8rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError(`logoS3key`)
          setLogoS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setLogoS3key('')
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '7px',
        imagePaddingY: '7px',
      },
    ]
    let tempdata = componentData.data

    setHeading1(tempdata.heading_1)
    setHeading2(tempdata.heading_2)
    setHeading3(tempdata.heading_3)
    setHeading4(tempdata.heading_4)
    setSignIn(tempdata?.sign_in)
    setCtaButton(tempdata.cta_button)
    setLogoS3key(tempdata.logo_s3key)

    imgData[0]['assetId'] = tempdata.logo_s3key
    imgData[0]['imageUrl'] = getThumbnail(
      userSessionObj.session_data.cf_domain_name,
      tempdata.logo_s3key,
    )

    setImageData(imgData)
  }, [])

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (logoS3key.trim().length === 0) {
      isFormValid = false
      temp.logoS3key = 'Upload Image!'
    }

    if (heading1.text.trim().length === 0) {
      isFormValid = false
      temp.heading1Text = 'Text One Cannot be Empty!'
    }
    if (signIn.text.trim().length === 0) {
      isFormValid = false
      temp.signIn = 'Sign In Text Cannot be Empty!'
    }
    if (ctaButton.text.trim().length === 0) {
      isFormValid = false
      temp.ctaButtonText = 'CTA Button Text Cannot be Empty!'
    }

    if (!validateLink(heading1.link).isValid) {
      isFormValid = false
      temp.heading1Link = validateLink(heading1.link).error
    }
    if (!validateLink(ctaButton.link).isValid) {
      isFormValid = false
      temp.ctaButtonLink = validateLink(ctaButton.link).error
    }
    if (!validateLink(signIn.link).isValid) {
      isFormValid = false
      temp.signInLink = validateLink(signIn.link).error
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return

    let elementObj = {
      logo_s3key: logoS3key,
      heading_1: heading1,
      heading_2: heading2,
      heading_3: heading3,
      heading_4: heading4,
      sign_in: signIn,
      cta_button: ctaButton,
    }

    modifyData(componentData.id, elementObj)
  }

  return (
    <>
      <CModal scrollable size="lg" className="" visible={true}>
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader className="d-flex justify-content-center">
          <p style={{ fontSize: '1.3rem' }}>
            <b style={{ fontWeight: '500' }}>Header Editor</b>
          </p>
        </CModalHeader>
        <CModalBody
          style={{ padding: '0 2rem 0 2rem', fontSize: '13px' }}
          className=" static-scrollbar-class"
        >
          <CRow className="my-3 px-3">
            <CCol>
              <h6 className="font-13px">
                Logo <span style={{ color: 'red' }}>*</span>
              </h6>
              <ImageUploader data={imageData} />
              <div className="message-text error-message">
                <p>{errorData.logoS3key}</p>
              </div>
            </CCol>
          </CRow>
          <div className="mt-5 border px-3 py-4 header-editor-box ">
            <h6 className="font-13px">
              Text One <span style={{ color: 'red' }}>*</span>
            </h6>
            <CustomDescriptionBox
              limit={18}
              rows={1}
              value={heading1.text}
              onChange={(value) => setHeading1((prev) => ({ ...prev, text: value }))}
              isMandatory={true}
              errorText={errorData?.heading1Text}
              style={{ fontSize: '13px' }}
            />
            <AttachLink
              linkData={heading1.link}
              id={'text1'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('heading1Link')
                setHeading1((prev) => ({ ...prev, link: value }))
              }}
              astrick={true}
            />
            <div className="message-text error-message">
              <p>{errorData?.heading1Link}</p>
            </div>
          </div>
          <div className="my-3 border px-3 py-4 header-editor-box ">
            <h6 className="font-13px">Text Two</h6>
            <CustomDescriptionBox
              limit={18}
              rows={1}
              value={heading2.text}
              onChange={(value) => setHeading2((prev) => ({ ...prev, text: value }))}
              style={{ fontSize: '13px' }}
            />

            <AttachLink
              linkData={heading2.link}
              id={'text2'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => setHeading2((prev) => ({ ...prev, link: value }))}
            />
          </div>
          <div className="my-3 border px-3 py-4 header-editor-box ">
            <h6 className="font-13px">Text Three</h6>
            <CustomDescriptionBox
              limit={18}
              rows={1}
              value={heading3.text}
              onChange={(value) => setHeading3((prev) => ({ ...prev, text: value }))}
              style={{ fontSize: '13px' }}
            />

            <AttachLink
              linkData={heading3.link}
              id={'text3'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => setHeading3((prev) => ({ ...prev, link: value }))}
            />
          </div>
          <div className="my-3 border px-3 py-4 header-editor-box ">
            <h6 className="font-13px">Text Four</h6>
            <CustomDescriptionBox
              limit={18}
              rows={1}
              value={heading4.text}
              onChange={(value) => setHeading4((prev) => ({ ...prev, text: value }))}
              style={{ fontSize: '13px' }}
            />
            <AttachLink
              linkData={heading4.link}
              id={'text4'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => setHeading4((prev) => ({ ...prev, link: value }))}
            />
          </div>
          <div className="my-3 border px-3 py-4 header-editor-box ">
            <h6 className="font-13px">
              Sign In <span style={{ color: 'red' }}>*</span>
            </h6>
            <CustomDescriptionBox
              limit={18}
              rows={1}
              value={signIn.text}
              onChange={(value) => setSignIn((prev) => ({ ...prev, text: value }))}
              isMandatory={true}
              errorText={errorData?.signIn}
              style={{ fontSize: '13px' }}
            />
            <AttachLink
              linkData={signIn.link}
              id={'ctaButton'}
              astrick={true}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('signInLink')
                setSignIn((prev) => ({ ...prev, link: value }))
              }}
              disabled={true}
            />
            <div className="message-text error-message">
              <p>{errorData?.signInLink}</p>
            </div>
          </div>
          <div className="my-3 border px-3 py-4 header-editor-box ">
            <h6 className="font-13px">
              CTA Button <span style={{ color: 'red' }}>*</span>
            </h6>
            <CustomDescriptionBox
              limit={18}
              rows={1}
              value={ctaButton.text}
              onChange={(value) => setCtaButton((prev) => ({ ...prev, text: value }))}
              isMandatory={true}
              errorText={errorData?.ctaButtonText}
              style={{ fontSize: '13px' }}
            />
            <AttachLink
              linkData={ctaButton.link}
              id={'ctaButton'}
              astrick={true}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('ctaButtonLink')
                setCtaButton((prev) => ({ ...prev, link: value }))
              }}
              disabled={true}
            />
            <div className="message-text error-message">
              <p>{errorData?.ctaButtonLink}</p>
            </div>
          </div>
        </CModalBody>
        <CModalFooter>
          <div className="mt-4 d-flex justify-content-end">
            <CButton
              style={{ color: 'black', border: '1px solid black' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton className=" bg-black rounded-1 btn-focus-none" onClick={handleSave}>
              Save
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default RosemaryHeaderModal
